import { getApi } from "../helpers/api";

async function init(endpoint: string, queryParams: string = "") {
  return await getApi().get(`/${endpoint}/init${queryParams}`);
}

export default init;
